import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const BRAND = "SeguraTech";
const TAGLINE = "Security, Reliability and Integrity, Delivered.";

export default function Website() {
  return (
    <div className="min-h-screen bg-[#111111] text-white scroll-smooth">
      <Helmet>
        <title>Home Security Installation in Sussex | SeguraTech</title>
        <meta
          name="description"
          content="SeguraTech provides professional home and business security installations across Sussex, including Ajax alarm systems, smart home integration, and secure keyholding."
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="SeguraTech | Security & Smart Home Systems in Sussex"
        />
        <meta
          property="og:description"
          content="Professional security installations and secure keyholding services across Sussex. Reliable, discreet, and built on integrity."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.seguratech.co.uk/" />
        <meta property="og:image" content="/STLogo.png" />
      </Helmet>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 pt-16 pb-12 md:pt-24 md:pb-24 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight tracking-tight text-[#C6A564]">
            {BRAND}: <span className="text-white/90">{TAGLINE}</span>
          </h1>
          <p className="mt-5 text-lg text-white/80">
            We build long-term trust by doing the right thing, communicating
            clearly, and standing by our work.
          </p>
        </div>
      </section>

      {/* Middle Feature Boxes */}
      <section className="max-w-6xl mx-auto px-4 pb-24">
        <div className="grid md:grid-cols-2 gap-8 text-center">
          {/* Alarm Systems Box */}
          <Link
            to="/alarms"
            className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition block"
          >
            <h2 className="text-2xl font-semibold text-[#C6A564] mb-3">
              Alarm Systems
            </h2>
            <p className="text-white/80">
              Advanced Ajax installations for reliable protection and effortless
              control.
            </p>
          </Link>

          {/* Smart Home Box */}
          <Link
            to="/smarthome"
            className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition block"
          >
            <h2 className="text-2xl font-semibold text-[#C6A564] mb-3">
              Smart Home
            </h2>
            <p className="text-white/80">
              Seamless automation for lighting, climate, and security all in one
              app.
            </p>
          </Link>

          {/* Secure Keyholding Box */}
          <Link
            to="/secure-keyholding"
            className="md:col-span-2 border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition block"
          >
            <h2 className="text-2xl font-semibold text-[#C6A564] mb-3">
              Secure Keyholding
            </h2>
            <p className="text-white/80">
              Secure key storage and rapid access when you need it most.
            </p>
          </Link>
        </div>
      </section>
    </div>
  );
}

